import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { compose, lifecycle, withProps, branch } from 'recompose';

import Input from '../Input';
import normalize from './normalize';
import format from './format';
import { useTranslation, withTranslation } from 'react-i18next';

const getDateFormat = (type) => {
  switch (type) {
    case 'date': {
      return moment.HTML5_FMT.DATE;
    }
    case 'time': {
      return moment.HTML5_FMT.TIME;
    }
    default: {
      return moment.HTML5_FMT.DATETIME_LOCAL_SECONDS;
    }
  }
};

const formatValue = type => (value) => {
  if (value) {
    switch (type) {
      case 'datetime-local': {
        return moment(value).format('YYYY-MM-DD HH:mm');
      }
      default: {
        return moment(value).format(getDateFormat(type)).toString();
      }
    }
  }
  return value;
};

function DateInput({ type, input, ...props }) {
  const { t } = useTranslation();
  const { labelCssClass, label, ...inputWithoutCustomProps } = input;

  return (
    <React.Fragment>
      {labelCssClass && <span className={labelCssClass}>{label && label}</span>}
      <Input
      type={type}
      placeholder={t("Datum")}
      input={{
        ...inputWithoutCustomProps,
        value: inputWithoutCustomProps.value,
        min: type === 'date' ? '1900-01-01' : undefined,
        max: type === 'date' ? '3000-12-31' : undefined,
      }}
      formatValue={formatValue(type)}
      {...props}
    />
    </React.Fragment>

  );
}

DateInput.defaultProps = {
  type: 'date',
};

DateInput.propTypes = {
  input: PropTypes.object.isRequired, // eslint-disable-line
  type: PropTypes.oneOf(['date', 'datetime-local', 'time']),
};

const extendedDateInput = compose(
  withTranslation(),
  branch(
    ({ nullToday }) => nullToday,
    withProps(({ input, type }) => {
      const value = input.value || moment().format(getDateFormat(type));
      return {
        input: {
          ...input,
          value,
        },
      };
    }),
  ),
  withProps(({ input, forceCheck, meta, t }) => {
    if (!forceCheck) {
      return {};
    }

    if ((!input.value || input.value.size === 0)) {
      return {
        indicator: true,
        meta: {
          ...meta,
          touched: true,
          error: t('Ett datum måste vara val'),
        },
      };
    }

    return {};
  }),
  lifecycle({
    componentWillMount() {
      if (this.props.defaultNow) {
        this.props.input.onChange(moment().format(getDateFormat(this.props.type)));
      }
    },
  }),
)(DateInput);
extendedDateInput.format = format;
extendedDateInput.normalize = normalize;

export default extendedDateInput;
